<template lang="pug">
	.active-status-confirmation-popup(v-if="showed")
		.card
			.card-header {{cardHeader}}
			.card-body
				span {{bodyText}}
			.card-footer
				button.btn.btn-cancel(@click="cancelStatus") Cancel
				button.btn.btn-confirm(type="submit" @click="setStatus") {{confirmButtonText}}

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'ActiveStatusConfirmationPopup',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {}
	},
	data() {

		this.Server = Server;

		return {
			cardHeader: 'Confirm status change',
			bodyText: 'Are you sure?',
			confirmButtonText: 'Ok'
		}
	},
	methods: {
		collectData(event, params) {
			console.log(event, params);

			this.type = params.type;

			this.cardHeader = `Confirm ${params.type} status change`;
			let status = params.newStatus ? 'active' : 'inactive'
			this.confirmButtonText = `Set ${status}`;

			if (params.type === 'order') {

				this.order = params.order;

				this.bodyText = `Changing this order to ${status} will set all campaigns associated with the order to be ${status}.\nChange "${params.order.name}" order to be ${status}?`;

			} else if (params.type === 'campaign') {

				this.campaign = params.campaign;

				this.bodyText = `Changing this campaign to ${status} will set the associated order to be ${status}.\nChange "${params.campaign.name}" campaign to be ${status}?`;

			}

		},
		cancelStatus() {

			if (this.type === 'order') Broadcast.call('Order Active Status Confirmation', [false]);
			else if (this.type === 'campaign') Broadcast.call('Campaign Active Status Confirmation', [false]);

			this.hide();

		},
		setStatus() {

			if (this.type === 'order') Broadcast.call('Order Active Status Confirmation', [true]);
			else if (this.type === 'campaign') Broadcast.call('Campaign Active Status Confirmation', [true]);

			this.hide();

		}

	}
}

</script>

<style lang="sass">

.active-status-confirmation-popup
	position: absolute
	z-index: 2001
	top: 0
	left: 0
	bottom: 0
	right: 0
	display: flex
	justify-content: center
	align-items: center
	background-color: rgba(0, 0, 0, 0.6)

	>.card
		width: 650px

		>.card-footer
			display: flex
			flex-direction: row
			justify-content: space-between

		>.card-body
			display: flex
			flex-direction: column
			gap: 0.5em
			height: 100px

</style>
